import React from 'react';
import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RootState } from '../../store';

interface ModuleRouteProps {
  children: React.ReactNode;
  moduleKey: string;
  // Optional list of roles allowed to access; if provided, user must have one of these roles too
  roles?: string[];
}

const ModuleRoute: React.FC<ModuleRouteProps> = ({ children, moduleKey, roles }) => {
  const { isAuthenticated, user } = useSelector((state: RootState) => state.auth);

  if (!isAuthenticated) {
    return <Navigate to="/login" />;
  }
  if (!user) return <div role="status">Loading access rights…</div>;

  const allowedModules: string[] = ((user as any)?.allowedmodules ?? []) as string[];
  const userRoles = (user.roles ?? [user.role]).map(r => r.trim().toLowerCase());
  const isAdmin = userRoles.includes('admin');
  // Dashboard is the authenticated landing page and remains available to all
  // users; the data shown there is still filtered by the backend permissions.
  const hasModule = isAdmin ? true : (!moduleKey || moduleKey === 'dashboard' || allowedModules.includes(moduleKey));
  const hasRole = isAdmin ? true : !roles || roles.length === 0 ? true : roles.some((r) => userRoles.includes(r.toLowerCase()));

  if (!hasModule || !hasRole) {
    // If lacking module or role, route to dashboard (or 403 page if you have one)
    return <Navigate to="/dashboard" />;
  }

  return <>{children}</>;
};

export default ModuleRoute;
